import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { makeStyles, createStyles } from '../../styles';
import { marginBetweenChildrenHorizontal } from '../../mixins';
export const PaperModalFooter = ({ className, children, }) => {
    const classes = useStyles();
    return _jsx("div", Object.assign({ className: cn(classes.root, className) }, { children: children }));
};
const useStyles = makeStyles((theme) => createStyles({
    root: Object.assign(Object.assign({}, marginBetweenChildrenHorizontal(16)), { position: 'relative', display: 'flex', padding: theme.spacing(4, 0), margin: theme.spacing(0, 4), borderTop: `1px solid ${theme.divider.primary}`, [theme.breakpoints.down('xs')]: {
            margin: theme.spacing(0, 2),
        } }),
}));
export default PaperModalFooter;
//# sourceMappingURL=PaperModalFooter.js.map